exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".App{background-color:#fefefe;text-align:center;height:100%;width:100%;-webkit-overflow-scrolling:touch}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss"}!./src/App.scss
// module id = 2126
// module chunks = 0